import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsAuthenticated, selectUser } from '../redux/authSlice';
import {
  initializeGlobalData,
  setActiveAccountId,
  fetchPerson,
  fetchOrgScopedFor,
} from '../redux/globalDataSlice';

const usePostLoginBootstrap = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const user = useSelector(selectUser);
  const initialized = useSelector((s) => s.globalData.initialized);
  const person = useSelector((s) => s.globalData.person);

  const hasHydratedRef = useRef(false);
  const hasBootstrappedRef = useRef(false);

  // 1) Hydrate saved account and load org-scoped data for it
  useEffect(() => {
    if (hasHydratedRef.current) return;
    hasHydratedRef.current = true;
    try {
      const saved = localStorage.getItem('activeAccountId');
      if (saved) {
        // This will set initialized=true via reducer; that's fine.
        dispatch(setActiveAccountId(saved));
        // Ensure org-scoped data is loaded for the hydrated account immediately.
        dispatch(fetchOrgScopedFor(saved));
      }
    } catch {}
  }, [dispatch]);

  // 2) Always ensure we have the person loaded (needed for AccountPicker)
  useEffect(() => {
    if (!isAuthenticated || !user?.email) return;
    if (!person) {
      dispatch(fetchPerson());
    }
  }, [isAuthenticated, user?.email, person, dispatch]);

  // 3) Run full bootstrap only once if not yet initialized (fresh session)
  useEffect(() => {
    if (!isAuthenticated || !user?.email) return;
    if (initialized) return;
    if (hasBootstrappedRef.current) return;
    hasBootstrappedRef.current = true;

    dispatch(initializeGlobalData());
  }, [isAuthenticated, user?.email, initialized, dispatch]);
};

export default usePostLoginBootstrap;
